import {
    getPrice,
    listPrices
} from './queries';
import {
    createPrice,
    deletePrice,
    updatePrice,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreatePrice,
    DeletePrice,
    GetPrice,
    ListPrices,
    Price,
    UpdatePrice
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {
    notifyError,
    notifySuccess
} from "../../../components/ServiceNotifications.tsx";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;

export const fetchRecords = async (productId: string, query: ListRecordsQuery) => {

    try {
        const response = await client.graphql<GraphQLQuery<ListPrices>>({
                                                                            query: listPrices,
                                                                            variables: {
                                                                                productId: productId,
                                                                                ...query
                                                                            },
                                                                        });

        return {
            items: response.data?.listPrices.items || [],
            nextToken: response.data?.listPrices.nextToken
        }
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetPrice>>({
                                                                          query: getPrice,
                                                                          variables: {id: id},
                                                                      });
        return response.data?.getPrice;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreatePrice>>({
                                                                             query: createPrice,
                                                                             variables: {input: payload},
                                                                         });
        console.debug('in the service response', response);
        notifySuccess('Price created');
        return response.data?.createPrice;
    } catch (e) {
        notifyError(e)
    }
};

export const update = async (id: string, record: Price) => {

    console.debug('IN UPDATE', id, record);

    // Only send fields allowed in UpdatePriceInput
    const updateInput = {
        id: record.id,
        productId: record.productId,
        recurringOption: record.recurringOption,
        priceStatus: record.priceStatus,
        pricingModel: record.pricingModel,
        amount: record.amount,
        ratePlanId: record.ratePlanId,
        description: record.description,
        billingPeriod: record.billingPeriod
    };

    try {
        const response = await client.graphql<GraphQLQuery<UpdatePrice>>({
                                                                             query: (updatePrice),
                                                                             variables: {input: updateInput},
                                                                         });
        notifySuccess('Price updated')
        return response.data?.updatePrice;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeletePrice>>({
                                                                             query: (deletePrice),
                                                                             variables: {input: {id: id}},

                                                                         });
        notifySuccess('Price deleted')
        return response.data?.deletePrice;
    } catch (e) {
        notifyError(e)
    }
};
